import React, { useState } from "react";

import { StyledTextAreaWrapper } from "./simpleTextArea.style";
import { Label } from "../genericInputField";

const SimpleTextArea = ({
  register,
  name,
  required,
  placeholder,
  error,
  maxCharacters,
  readOnly,
  label = undefined,
  ...rest
}) => {
  const [inputLength, setInputLength] = useState(0);

  const withRegister = () => {
    if (!register) return null;

    const { onChange, onBlur, ref } = register(name, {
      required: {
        value: required,
        message: "This field is required",
      },
      maxLength: {
        value: maxCharacters,
        message: `Maximum length is ${maxCharacters} characters`,
      },
      onChange: (e) => setInputLength(e.target.value.length),
    });

    return {
      onChange,
      name,
      onBlur,
      ref,
    };
  };

  return (
    <StyledTextAreaWrapper error={error ? 1 : 0}>
      <div className="input">
        {label && <Label required={required}>{label}</Label>}
        <textarea
          {...withRegister()}
          {...rest}
          placeholder={placeholder}
          maxLength={maxCharacters}
          rows="4"
          readOnly={readOnly}
        />
      </div>
      {maxCharacters && (
        <div className="counter">
          <span>{inputLength}</span> / {maxCharacters} Characters
        </div>
      )}
      <span className="error">{error?.message || ""}</span>
    </StyledTextAreaWrapper>
  );
};

export default SimpleTextArea;
